  <div class="alert-default clearfix {{t type}} {{#unless visibility}}hidden-accessible-text{{/unless}}">
     {{>icon uuid=(concat type '__alert__icon') icon=ico classes=(concat type '__alert__icon p-inset-xs')}}
     <span class="alert__container">
       <p class="alert__container__title">{{t title}}</p>
       <p class="alert__container__message">{{t body}}</p>
     </span>
  </div>
